import * as React from "react";
import { Button, Divider, Row, Tabs, Tree, Input, Col } from "antd";
import TreeNodeTitle from "./TreeNodeGroupTitle";
import IndexData from "./IndexData";
import { TOrganisationIndexPresentationModel } from "../../presenter/model/OrganisationIndexPresentationModel";
import { TIndexTypeGroupPresentationModel } from "../../presenter/model/IndexTypeGroupPresentationModel";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";
import IndexGroupData from "./IndexGroupData";
import { TOrganisationIndexGroupPresentationModel } from "../../presenter/model/OrganisationIndexGroupPresentationModel";
import { IOrganisationIndex } from "../../model/OrganisationIndex";
const { Search } = Input;
const { TreeNode } = Tree;
const { TabPane } = Tabs;

export interface Props {
  translate: any;
  organisationIndexDataTree: TIndexTypeGroupPresentationModel[];
  changeCreateGroupModalVisible;
  changeCreateItemModalVisible;
  searchDataTree: (searchValue: string) => void;
  selectOrganisationIndex: any;
  selectOrganisationIndexGroup: any;
  indexInfoVisible: any;
  groupInfoVisible: boolean;
  hierarchyList?: any[];
  connectedIndexes?: TOrganisationIndexPresentationModel[];
  connectedIndexGroups?: TOrganisationIndexGroupPresentationModel[];
  clickedIndex?: TOrganisationIndexPresentationModel;
  clickedGroup?: IOrganisationIndexGroup;
  findConnectionCandidatesForIndex: any;
  findConnectionCandidatesForGroup: any;
  changeUpdateIndexModalVisible: any;
  changeUpdateIndexGroupModalVisible: any;
  canEdit: any;
  getCaseLawDocumentsForIndex: any;
  removeOrganisationIndex: any;
  caseLawDocuments: any;
  getSwitchGroupCandidates: any;
  checkCanGroupBeRemoved: any;
  connectionCandidatesByCategory?: IOrganisationIndex[];
  changeIndexesByCategoryModalVisible?: any;
  findConnectionCandidatesByCategory?: any;
  indexesByCategoryModalVisible?: boolean;
  connectedIndexesByCategory: IOrganisationIndex[];
}

export interface State {
  searchValue: string;
}

export default class OrganisationIndexGroupTree extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ""
    };
  }

  render() {
    const {
      organisationIndexDataTree,
      changeCreateGroupModalVisible,
      changeCreateItemModalVisible,
      searchDataTree,
      selectOrganisationIndex,
      changeUpdateIndexModalVisible,
      selectOrganisationIndexGroup,
      clickedIndex,
      clickedGroup,
      translate,
      connectedIndexes,
      connectedIndexGroups,
      indexInfoVisible,
      groupInfoVisible,
      changeUpdateIndexGroupModalVisible,
      canEdit,
      getCaseLawDocumentsForIndex,
      removeOrganisationIndex,
      caseLawDocuments,
      getSwitchGroupCandidates,
      checkCanGroupBeRemoved,
      connectionCandidatesByCategory,
      changeIndexesByCategoryModalVisible,
      findConnectionCandidatesByCategory,
      indexesByCategoryModalVisible,
      connectedIndexesByCategory
    } = this.props;

    const onChange = (value: string) => {
      this.setState({
        searchValue: value
      });
      searchDataTree(value);
    };
    const onChangeOnEnter = (e) => {
      const { value } = e.target;

      onChange(value);
    };

    const isSearchValue = (name) => {
      return (
        name?.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !==
        -1 && this.state.searchValue?.length > 0
      );
    };
    const whatShouldRender = (
      data: TIndexTypeGroupPresentationModel,
      item: TIndexTypeGroupPresentationModel,
      group
    ) => {
      if (
        item.childGroups?.length === 0 &&
        item.childIds?.includes(item.id) &&
        data.childIds?.includes(item.id)
      ) {
        return renderTreeNodes(data, group.id);
      } else if (
        item.childIds?.length > 1 &&
        item.childGroups?.length !== item.childIds.length &&
        item.childIds?.includes(item.id) &&
        data.childIds?.includes(item.id)
      ) {
        let itemItself = data.childGroups.find((elem) => elem.id === item.id);
        itemItself && item.childGroups.push(itemItself);
        return renderTreeNodes(item, group.id);
      } else {
        return renderTreeNodes(item, group.id);
      }
    };
    const renderTreeNodes = (
      data: TIndexTypeGroupPresentationModel,
      organisationGroupId: number
    ) => {
      return data?.childGroups?.map((item) => {
        if (item.organisationIndexGroupList) {
          return item.organisationIndexGroupList?.map((group) => {
            return group.parentId === organisationGroupId ? (
              <TreeNode
                title={
                  <div
                    className={"descriptor-button"}
                    onClick={() => selectOrganisationIndexGroup(group)}
                  >
                    <TreeNodeTitle
                      translate={this.props.translate}
                      item={item}
                      group={group}
                      childGroups={
                        item.childGroups && item.childGroups.length > 0
                          ? item.childGroups
                          : data.childGroups
                      }
                      changeCreateGroupModalVisible={
                        changeCreateGroupModalVisible
                      }
                      style={
                        isSearchValue(group.nameTranslation ?? group.name)
                          ? { color: "#f50", cursor: "pointer" }
                          : { cursor: "pointer" }
                      }
                      changeCreateItemModalVisible={
                        changeCreateItemModalVisible
                      }
                      canEdit={canEdit}
                    />
                  </div>
                }
                key={group.id + group.name}
              >
                {whatShouldRender(data, item, group)}
                {group.organisationIndexList?.map((indexItem, index) => (
                  <TreeNode
                    title={
                      <Row>
                        <div
                          style={{
                            display: "flex"
                          }}
                        >
                          <div
                            className={"descriptor-button"}
                            style={
                              isSearchValue(
                                indexItem.nameTranslation ?? indexItem.name
                              )
                                ? { color: "#f50" }
                                : {}
                            }
                            onClick={() => selectOrganisationIndex(indexItem)}
                          >
                            {indexItem.nameTranslation ?? indexItem.name}
                          </div>
                        </div>
                      </Row>
                    }
                    key={indexItem.id + item.name}
                  />
                ))}
              </TreeNode>
            ) : null;
          });
        }
        return (
          <TreeNode
            title={
              <Row>
                <div>{item.nameTranslation ?? item.name}</div>
              </Row>
            }
            key={item.id + item.name}
          />
        );
      });
    };
    return (
      <div>
        <Search
          style={{ marginBottom: 8 }}
          placeholder="Search"
          onSearch={(value) => onChange(value)}
          onPressEnter={(value) => onChangeOnEnter(value)}
        />
        {organisationIndexDataTree.map((descriptor) => {
          return (
            <Tabs
              defaultActiveKey="0"
              type="card"
              className={"dashboard-content-tab"}
              tabBarExtraContent={
                canEdit() && (
                  <Button
                    type={"primary"}
                    onClick={() => {
                      changeCreateGroupModalVisible(true, descriptor.id, null);
                    }}
                  >
                    {`+ ${descriptor.nameTranslation ?? descriptor.name}`}
                  </Button>
                )
              }
            >
              {descriptor.organisationIndexGroupList?.map((elem, index) => {
                return (
                  <TabPane
                    tab={elem.nameTranslation ?? elem.name}
                    key={index.toString()}
                  >
                    <Row>
                      <Col
                        style={{
                          overflowY: "auto",
                          height: "100vh"
                        }}
                        span={9}
                      >
                        {canEdit() &&
                          descriptor.childGroups?.map((childGroup) => (
                            <Button
                              onClick={() => {
                                changeCreateGroupModalVisible(
                                  true,
                                  childGroup.id,
                                  elem.id
                                );
                              }}
                            >
                              {`+ ${childGroup.nameTranslation ?? childGroup.name
                                }`}
                            </Button>
                          ))}

                        <Divider
                          type={"horizontal"}
                          className={"divider-horizontal"}
                        />

                        <Row>
                          <Col>
                            {elem.organisationIndexList?.map((indexItem) => (
                              <TreeNode
                                title={
                                  <Row>
                                    <div>
                                      {indexItem.nameTranslation ??
                                        indexItem.name}
                                    </div>
                                  </Row>
                                }
                                key={indexItem.id + indexItem.name}
                              />
                            ))}
                            <Tree
                              defaultExpandAll
                              selectable={false}
                              className={"png-tree"}
                            >
                              {renderTreeNodes(descriptor || [], elem.id)}
                            </Tree>
                          </Col>
                        </Row>
                      </Col>
                      <Col style={{ overflow: "initial" }} span={15}>
                        {clickedIndex ? (
                          <Row style={{ height: "100%" }}>
                            <Col span={20} offset={2}>
                              <IndexData
                                translate={translate}
                                connectedIndexes={connectedIndexes}
                                indexInfoVisible={indexInfoVisible}
                                clickedIndex={clickedIndex}
                                findConnectionCandidatesForIndex={
                                  this.props.findConnectionCandidatesForIndex
                                }
                                changeUpdateIndexModalVisible={
                                  changeUpdateIndexModalVisible
                                }
                                canEdit={canEdit}
                                getCaseLawDocumentsForIndex={
                                  getCaseLawDocumentsForIndex
                                }
                                removeOrganisationIndex={
                                  removeOrganisationIndex
                                }
                                caseLawDocuments={caseLawDocuments}
                                getSwitchGroupCandidates={
                                  getSwitchGroupCandidates
                                }
                                connectionCandidatesByCategory={
                                  connectionCandidatesByCategory
                                }
                                changeIndexesByCategoryModalVisible={
                                  changeIndexesByCategoryModalVisible
                                }
                                findConnectionCandidatesByCategory={
                                  findConnectionCandidatesByCategory
                                }
                                indexesByCategoryModalVisible={
                                  indexesByCategoryModalVisible
                                }
                                connectedIndexesByCategory={
                                  connectedIndexesByCategory
                                }
                              />
                            </Col>
                          </Row>
                        ) : null}
                        {clickedGroup && groupInfoVisible ? (
                          <Row style={{ height: "100%" }}>
                            <Col span={20} offset={2}>
                              <IndexGroupData
                                translate={translate}
                                groupInfoVisible={groupInfoVisible}
                                connectedIndexGroups={connectedIndexGroups}
                                clickedGroup={clickedGroup}
                                changeUpdateIndexGroupModalVisible={
                                  changeUpdateIndexGroupModalVisible
                                }
                                findConnectionCandidatesForGroup={
                                  this.props.findConnectionCandidatesForGroup
                                }
                                canEdit={canEdit}
                                checkCanGroupBeRemoved={checkCanGroupBeRemoved}
                              />
                            </Col>
                          </Row>
                        ) : null}
                      </Col>
                    </Row>
                  </TabPane>
                );
              })}
            </Tabs>
          );
        })}
      </div>
    );
  }
}
